import { observable } from 'mobx';

import { EntryLongList } from '@patient/store/entry/EntryLongList';

export class EntryListStore {
    public static Name = 'entryListStore' as const;

    @observable public entryList = new EntryLongList();
}

export const entryListStore = new EntryListStore();
